import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

/**
 * Kerangka tabel selama data dimuat.
 *
 * Jumlah sel per baris mengikuti `columnRefs`, bukan angka tetap: dulu
 * dipatok 5 sel sehingga di tabel berkolom 6 (mis. /pencipta) kerangkanya
 * tidak sejajar dengan header, dan tabel seperti bergeser saat data masuk.
 */
export default function TableLoading({ columnRefs = [], isShow }) {
  const rowCount = Number(isShow) || 0;

  return (
    <>
      <SkeletonTheme
        // Warna kerangka ikut token: nilai terangnya (#d6d6d6 / #f5f6f7)
        // menyala terlalu kuat di atas permukaan gelap.
        baseColor="var(--surface-3)"
        highlightColor="var(--surface-2)"
        borderRadius="0.5rem"
        duration={1}
      >
        <table className="table">
          <thead>
            <tr>
              {columnRefs.map((val, index) => (
                <th key={index} style={val.headerStyle}>
                  {val.text}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: rowCount }, (_, rowIndex) => (
              <tr key={rowIndex}>
                {columnRefs.map((val, colIndex) => (
                  <td key={colIndex} style={val.style}>
                    <Skeleton inline width={90} />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </SkeletonTheme>
    </>
  );
}
